import React, { useEffect } from 'react';
import { setAppHideConfig } from 'src/models/appConfig/slice';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { getWorkspaceRouteModuleBreadcrumbs } from 'src/workspace/selectors';
import BreadcrumbHeader from './breadcrumbHeader';

function Breadcrumb() {
  const {
    design,
    items: navigationItems,
    hidden,
    titleComponent,
  }: any = useAppSelector(getWorkspaceRouteModuleBreadcrumbs);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (navigationItems?.length) {
      dispatch(setAppHideConfig({ hide: { sidebar: true } }));
    } else {
      dispatch(setAppHideConfig({ hide: { sidebar: false } }));
    }
  }, [dispatch, navigationItems]);

  if (navigationItems?.length > 0 && !hidden) {
    return (
      <BreadcrumbHeader
        design={design}
        navigationItems={navigationItems}
        titleComponent={titleComponent}
      />
    );
  }

  return null;
}

export default Breadcrumb;
